import { useContext } from 'react';

import { ChannelContext } from './channel-context';

// ----------------------------------------------------------------------

export function useChannelContext() {
  const context = useContext(ChannelContext);

  if (!context) throw new Error('useCheckoutContext must be use inside CheckoutProvider');

  return context;
}
